<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <CommonTitle :titleProps="'振替伝票の作成'" class="fs-24-bold"/>
        <!-- コンテンツ領域 -->
        <p class="m-0 mb-3 small fs-14-regular">アプラスへの振込伝票データを作成、送信します。</p>
        <b-card>
        <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
              <b-form @submit.stop.prevent="load(searchParams)" novalidate>
                <b-collapse id="open-form" v-model="visible" class="mb-3">
                      <!--                      <b-row class="m-0 p-0">-->
                      <b-row class="m-0 p-0">
                        <b-col cols="3" class="w-100 p-0 pr-2">
                          <label class="mb-2">TAS ID</label>
                          <validation-provider class="fs-12-bold" name="TAS ID" :rules="{ max: 100 }" v-slot="validationContext">
                            <b-form-group class="m-0">
                              <b-form-input
                                type="text"
                                v-model="searchParams.searchTextTasId"
                                :state="getValidationState(validationContext)"
                                aria-describedby="input-tasId-live-feedback"
                              />
                              <b-form-invalid-feedback id="input-tasId-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="3" class="w-100 p-0 pr-2">
                          <label class="mb-2">状況</label>
                          <b-form-select
                            v-model="searchParams.selectedStatus"
                            :options="statusOptions"
                          />
                        </b-col>
                        <b-col cols="3" class="w-100 p-0">
                          <label class="mb-2">請求書発行月</label>
                          <validation-observer vid="invoice-issuance-month" v-slot="validationContext">
                            <div class="box-input-ranger">
                              <div class="content-input">
                                <div class="input-date">
                                  <validation-provider
                                    class="m-0"
                                    name="請求書発行月の開始月"
                                    :rules="{
                              validityStateCheck: $refs['from-invoice-issuance-month'] ? {
                                target: $refs['from-invoice-issuance-month']
                              } : false,
                              monthCheck: true
                            }"
                                    ref="fromInvoiceIssuanceMonth"
                                    v-slot="validationContext"
                                  >
                                    <b-form-input
                                      type="month"
                                      max="9999-12"
                                      v-model="searchParams.fromInvoiceIssuanceMonth"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="input-from-invoice-issuance-month-live-feedback"
                                      ref="from-invoice-issuance-month"
                                    />
                                    <b-form-invalid-feedback
                                      id="input-from-invoice-issuance-month-live-feedback"
                                    >
                                      {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                  </validation-provider>
                                </div>
                                <div class="icon-space">
                                  <div class="align-middle">〜</div>
                                </div>
                                <div class="input-date">
                                  <validation-provider
                                    class="m-0"
                                    name="請求書発行月の終了月"
                                    :rules="{
                              validityStateCheck: $refs['to-invoice-issuance-month'] ? {
                                target: $refs['to-invoice-issuance-month']
                              } : false,
                              monthCheck: true,
                              dateDiffCheckOrSameMonth: {
                                start: searchParams.fromInvoiceIssuanceMonth,
                                end: searchParams.toInvoiceIssuanceMonth
                              }
                            }"
                                    ref="toInvoiceIssuanceMonth"
                                    v-slot="validationContext"
                                  >
                                    <b-form-input
                                      type="month"
                                      max="9999-12"
                                      v-model="searchParams.toInvoiceIssuanceMonth"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="input-to-invoice-issuance-month-live-feedback"
                                      ref="to-invoice-issuance-month"
                                    />
                                    <b-form-invalid-feedback
                                      id="input-to-invoice-issuance-month-live-feedback"
                                    >
                                      {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                  </validation-provider>
                                </div>
                              </div>
                              <div class="icon-clear" @click="invoiceIssuanceMonthClear" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                  <g id="Group_1089" data-name="Group 1089" transform="translate(-1046 -235)">
                                    <rect id="Rectangle_370" data-name="Rectangle 370" width="16" height="16" rx="8" transform="translate(1046 235)" fill="#eceff2"/>
                                  </g>
                                  <g id="Group_1091" data-name="Group 1091" transform="translate(-500 -440)">
                                    <line id="Line_176" data-name="Line 176" x2="8" transform="translate(505.172 445.171) rotate(45)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                                    <g id="Group_1090" data-name="Group 1090" transform="translate(465.574 -228.701) rotate(45)">
                                      <line id="Line_177" data-name="Line 177" x2="8" transform="translate(508.5 444.5) rotate(90)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                                    </g>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </validation-observer>
                        </b-col>
                      </b-row>
                </b-collapse>
                <div class="p-0 m-0 d-flex flex-wrap justify-content-between align-items-end">
                  <div @click="visible = !visible" class="cursor-pointer fs-14-bold">
                    <div v-if="visible">
                      閉じる <font-awesome-icon icon="chevron-up" />
                    </div>
                    <div v-if="!visible">
                      詳細検索 <font-awesome-icon icon="chevron-down" />
                    </div>
                  </div>
                  <div>
                      <b-button size="sm" class="clear__btn fs-14-bold"  variant="outline-secondary" @click="searchItemClear" pill>検索項目をクリア</b-button>
                      <b-button size="sm" class="submit__btn ml-3 bg-primary fs-14-bold text-white btn-under-2-char" variant="transparent" type="submit" pill>検索</b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
        </b-card>
<!--          <b-col cols="12" class="w-100 p-0 pl-3 pr-3 mt-4">-->
<!--            <b-form inline class="align-content-center justify-content-between">-->
<!--              <b-form-checkbox id="checkbox-all" v-model="checkAll">全て選択</b-form-checkbox>-->
<!--              <b-form-checkbox id="checkbox-exclude" v-model="isFilterOutputAndCompleted" size="sm" @change="filterOutputAndCompleted">出力済と完了を除外する</b-form-checkbox>-->
<!--              <b-form inline>-->
<!--                <b-form-input size="sm" type="month" class="mr-1" v-model="targetDate" @change="getPageList" />-->
<!--                <b-form-text>月請求書発行分のみ表示</b-form-text>-->
<!--                <b-form-checkbox class="ml-1" v-model="isDateSelected" true-value="true" false-value="false" @change="filterDateSelected" />-->
<!--              </b-form>-->
<!--            </b-form>-->
<!--          </b-col>-->
<!--          <b-col cols="12" class="w-100 p-0 mt-3 text-center">-->
<!--            <b-button size="sm" class="mr-4 w-100" style="max-width: 300px;" variant="primary" :disabled="selectItem.length === 0" v-b-modal.modal-1>選択した顧客の、出力済振替伝票<br>データを未出力に戻す</b-button>-->
<!--            <b-button size="sm" class="ml-4 w-100" style="max-width: 300px;" variant="primary" :disabled="selectItem.length === 0" @click="onclickOutput">選択した顧客の、振替伝票<br>データを出力する</b-button>-->
<!--          </b-col>-->
        <b-card class="mt-3">
          <b-row class="p-0 m-0 align-items-center">
            <b-col cols="5" class="p-0 d-flex">
              <b-form inline class="mr-2">
                <b-form-checkbox id="checkbox-all" @change="selectAllCheckToggle($event)" v-model="isAllChecked">全て選択</b-form-checkbox>
                <!--                  <b-form-input size="sm" class="w-100" style="max-width: 200px; border-radius: 0.25rem 0 0 0.25rem;" v-model="searchTextTasId" placeholder="TASIDで検索" />-->
                <!--                  <b-button variant="primary" style="border-radius: 0 0.25rem 0.25rem 0;" size="sm" @click="searchTasId">検索</b-button>-->
              </b-form>
              <CommonSelectAction
                :options="selectActions"
                :state="stateSelectActions"
                @changeSelect="changeSelectAction"
              />
            </b-col>
<!--            <b-col cols="1" class="w-100 p-0">-->
<!--              -->
<!--            </b-col>-->
<!--            <b-col cols="3" class="w-100 p-0 text-center">-->
<!--              -->
<!--            </b-col>-->
            <b-col cols="7" class="w-100 p-0">
              <CommonPagination
                  :listTotalRowCountProps="computedListTotalRowCount"
                  :perPageProps="computedPerPage"
                  :currentPageProps="computedCurrentPage"
                  :perPageoptionRestrictionsProps="true"
                  @searchingAgain="pagingSearchingAgain"
                  @changePerPage="onShowRowCountButonClick"
                  :is-show-page-options="false"
              />
            </b-col>
          </b-row>
          <b-row class="mt-2 p-0 m-0">
          <b-col cols="12" class="p-0 m-0">
<!-- onFiltere の機能確認が必要な為、コメントアウト
            <CommonTable
              id="table_customer_list"
              class="pointer"
              ref="selectableTable"
              :tableItemsProps="computedItems"
              :fieldsProps="fields"
              :sortByKeyNameProps="sortByKeyName"
              :sortDescSyncProps="sortDescSync"
              :selectModeProps="'multi'"
              :hoverProps="true"
              :noSortResetProps="true"
              :noProviderSortingProps="true"
              :noLocalSortingProps="true"
              :no-local-sorting=true
              @onRowClicked="onRowSelected"
              @onSortChange="sortChanged"
              @onFiltere="onFiltered"
            >
-->
            <CommonColumnDragTable
              id="table_customer_list"
              ref="selectableTable"
              v-model="fields"
              :items="tableItems"
              :selectable="true"
              :selectMode="'multi'"
              :hover="true"
              @rowClicked="onRowSelected"
              @sortChange="sortChanged"
            >
              <template v-slot:select="row">
                <div class="text-center">
                  <b-form-checkbox
                    v-model="row.selected"
                  />
                </div>
              </template>
              <template v-slot:earmarking_year_month="row">
                <span style="white-space: pre-line">{{ row.earmarking_year_month }}
                </span>
              </template>
              <template v-slot:amount_billed_total="row">
                <span style="white-space: pre-line">{{ row.amount_billed_total }}
                </span>
              </template>
            </CommonColumnDragTable>
          </b-col>
        </b-row>
          <b-row class="p-0 m-0 align-items-center">
            <b-col cols="5" class="p-0 d-flex">
              <b-form inline class="mr-2">
                <b-form-checkbox id="checkbox-all" @change="selectAllCheckToggle($event)" v-model="isAllChecked">全て選択</b-form-checkbox>
                <!--                  <b-form-input size="sm" class="w-100" style="max-width: 200px; border-radius: 0.25rem 0 0 0.25rem;" v-model="searchTextTasId" placeholder="TASIDで検索" />-->
                <!--                  <b-button variant="primary" style="border-radius: 0 0.25rem 0.25rem 0;" size="sm" @click="searchTasId">検索</b-button>-->
              </b-form>
              <CommonSelectAction
                :options="selectActions"
                :state="stateSelectActions"
                @changeSelect="changeSelectAction"
              />
            </b-col>
            <b-col cols="7" class="w-100 p-0">
              <CommonPagination
                :listTotalRowCountProps="computedListTotalRowCount"
                :perPageProps="computedPerPage"
                :currentPageProps="computedCurrentPage"
                :perPageoptionRestrictionsProps="true"
                @searchingAgain="pagingSearchingAgain"
                @changePerPage="onShowRowCountButonClick"
                :is-show-page-options="false"
              />
            </b-col>
          </b-row>
          <b-row class="mt-2 p-0 m-0">
            <b-col cols="6" class="clearfix pl-0">
              <b-input-group class="border-bottom-secondary-dashed-2">
                <b-input-group-text class="border-0 bg-transparent fs-14-regular p-0">請求件数 :</b-input-group-text>
                <b-form-input class="border-0 bg-transparent fs-14-regular p-0 pl-1" v-model="computedInvoiceListCount"/>
              </b-input-group>
            </b-col>
            <b-col cols="6" class="clearfix pr-0">
              <b-input-group class="border-bottom-secondary-dashed-2">
                <b-input-group-text class="border-0 bg-transparent fs-14-regular p-0">合計金額 :</b-input-group-text>
                <b-form-input class="border-0 fs-14-regular p-0 pl-1" :value="computedListBilledAmountTotal"/>
              </b-input-group>
            </b-col>
          </b-row>
        </b-card>
      </main>
      <!-- 未出力に戻す -->
      <b-modal centered id="modal-1" ref="ref-modal-1" content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close()"/>
        </template>
        <p>現在選択中の顧客の、振替伝票データを未出力に戻します。</p>
        <p class="m-0">よろしいですか？</p>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100">
            <b-col cols="6" class="text-center d-flex justify-content-end px-2">
              <b-button pill class="cancel__btn fs-14-bold" variant="outline-secondary" @click="cancel">キャンセル</b-button>
            </b-col>
            <b-col cols="6" class="text-center d-flex justify-content-start px-2">
              <b-button pill class="fs-14-bold" variant="primary" @click="ok, changeToNoOutput()">未出力に戻す</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>
      <!-- 出力する -->
      <b-modal centered id="modal-2" ref="modal-output" content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close()"/>
        </template>
        <p>現在選択中の顧客の、振替伝票データを出力します。</p>
        <p class="m-0">よろしいですか？</p>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100">
            <b-col cols="6" class="text-center d-flex justify-content-end px-2 ">
              <b-button pill class="fs-14-bold" variant="outline-secondary" @click="cancel">キャンセル</b-button>
            </b-col>
            <b-col cols="6" class="text-center d-flex justify-content-start px-2">
              <b-button pill class="fs-14-bold output__btn" variant="primary" @click="ok, changeOutput()">出力する</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>
      <!-- TODO: 選択されていないのにボタンが押せてしまうのはおかしいので、修正した方が良さそう -->
      <b-modal id="modal-3" ref="modal-output-none" ok-only>
        <p class="m-0">出力可能な項目が選択されていません</p>
      </b-modal>
      <!-- コメントをクリックした時のポップアップ -->
      <b-modal ref="my-modal" size="md" hide-footer hide-header>
        <b-row class="m-md-1">
          <b-col>{{detailTitle}}</b-col>
        </b-row>
        <b-row class="m-md-1">
          <b-col>
            <b-textarea id="comment-body" v-model="detailBody" disabled placeholder="コメント" rows="4" />
          </b-col>
        </b-row>
      </b-modal>
      <!-- ローディング -->
      <!-- <b-modal ref="refProcessingModal" centered title="ローディング" v-model="isBusy" hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
        <div class="text-center">
          <b-spinner label="Spinning" />
        </div>
      </b-modal> -->
      <b-modal ref="refProcessingModal" centered :title="isLoadingTxt" v-model="isBusy" hide-footer hide-header hide-header-close no-close-on-backdrop no-close-on-esc>
        <div class="text-center">
          <CommonLoader :title="isLoadingTxt"/>
        </div>
      </b-modal>
      <!-- NOTE: validateチェックアラート -->
      <common-validate-check-alert
        @isValidAlertClose="alertClose"
        :isValidAlertProps="isValidAlert"
        :isValidAlertMessageProps="isValidAlertMessage"
      />
    </b-container>
  </div>
</template>

<script>

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../../utils/loading-text-util'

// NOTE: カラムドラッグテーブルUI
import CommonColumnDragTable from '@/components/common/CommonColumnDragTable'

// NOTE: 共通ページネーションUI
import CommonPagination from '../../../components/common/CommonPagination'

// NOTE: バリデートアラート表示コンポーネント
import CommonValidateCheckAlert from '../../../components/common/CommonValidateCheckAlert'

import CommonSelectAction from '../../../components/common/CommonSelectAction'

// NOTE: 共通タイトルUI
import CommonTitle from '../../../components/common/CommonTitle'
import ToastTextUtil from '../../../utils/toast-text-util'
import CommonModalButtonClose from '@/components/common/CommonModalButtonClose.vue'
import CommonLoader from '../../../components/common/CommonLoader'

// import { mapActions, mapGetters } from 'vuex'
// import { SET_SEARCH_ITEM, SET_SELECT_ITEM, SET_SELECT_ALL_FLAG } from '../../../modules/common/mutation-types'

export default {
  title: 'headlines',
  publish_date: 'headlines',
  components: {
    CommonColumnDragTable,
    CommonPagination,
    CommonTitle,
    CommonValidateCheckAlert,
    CommonModalButtonClose,
    CommonSelectAction,
    CommonLoader
  },
  data () {
    return {
      isAllChecked: false,
      isLoadingTxt: '',
      isBusy: false,
      // allSelected: null,
      isDateSelected: false,
      // isFilterOutputAndCompleted: false,
      targetDate: '',
      listTotalRowCount: 0,
      filteredListTotalRowCount: 0,

      searchParams: {
        fromInvoiceIssuanceMonth: null,
        toInvoiceIssuanceMonth: null,
        searchTextTasId: null,
        selectedStatus: null,
        page: 1,
        limit: 20,
        sort: null,
        desc: null
      },
      tmpSearchParams: {
        page: 1,
        limit: 20
      },

      selectedStatus: 0,
      statusOptions: [
        { value: 0, text: '未選択' },
        { value: 1, text: '未出力' },
        { value: 2, text: '出力済' },
        { value: 3, text: '完了' },
        { value: 4, text: '作成不要' }
      ],

      fields: [
        // { key: 'ID', sortable: true },
        { key: 'select', label: '選択', sortable: false },
        { key: 'tas_id', label: 'TAS ID', sortable: true },
        { key: 'invoice_number', label: '請求番号', sortable: true },
        { key: 'corporate_name', label: '顧客名', sortable: true },
        {
          key: 'earmarking_year_month',
          label: '計上年月',
          sortable: true,
          // formatter: (value, key, item) => {
          //   let valueStr = String(value)
          //   return valueStr.substring(0, 10)
          // },
          // sortByFormatted: true,
          // filterByFormatted: true
          thClass: 'text-white white-space pre-line'
        },
        // { key: 'amount_billed_total', label: '請求金額', sortable: true },
        // { key: 'billed_count', label: '請求件数', sortable: true },
        // { key: 'billed_total', label: '請求合計', sortable: true },
        {
          key: 'invoice_made_year_month',
          label: '請求書発行月',
          sortable: true,
          formatter: (value, key, item) => {
            try {
              return value.substring(0, 7)
            } catch (e) {
              return '0000-00'
            }
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'invoice_status_str',
          label: '状況',
          sortable: true
          // formatter: (value, key, item) => {
          //   let str = ''
          //   switch (value) {
          //     case 5:
          //       str = '未出力'
          //       break
          //     case 6:
          //       str = '出力済'
          //       break
          //     case 7:
          //       str = '完了'
          //       break
          //     case 9:
          //       str = '作成不要'
          //       break
          //     // 0-4 , 10-11 も未出力扱いとする
          //     case 0:
          //     case 1:
          //     case 2:
          //     case 3:
          //     case 4:
          //     case 10:
          //     case 11:
          //       str = '未出力'
          //       break
          //   }
          //   return str
          // },
          // sortByFormatted: false,
          // filterByFormatted: true
        },
        {
          key: 'amount_billed_total',
          label: '請求金額',
          sortable: true,
          formatter: (value, key, item) => {
            try {
              return value.toLocaleString()
            } catch (e) {
              return 0
            }
          }
        }
      ],
      tableItems: [], // テーブルに表示されているデータ
      selectItem: [], // 選択された内部保持データ('ID','invoice_number','invoice_status','amount_billed_total' のみ)
      // filteredTableItems: [],
      pagerItems: [{}],
      showRowCount: 2,
      sortByKeyName: 'invoice_made_year_month',
      sortDescSync: true,
      // selectedItems: [],
      // items: [],

      // Transition name
      transProps: {
        name: 'flip-list'
      },

      // モーダル
      detailTitle: '',
      detailBody: '',

      breakFlag: false,
      checkAllFlag: false,

      // サイドメニュー登録用ID群 不要化
      // sideMenuIds: [],
      // isPutBuckTransferSlipDisabled: true,
      // isOutputTransferSlipDisabled: true,
      pargingTotal: 0, //  リストの総件数
      isValidAlert: false,
      isValidAlertMessage: [],
      selected: 0,
      visible: true
    }
  },
  // サイドメニュー仕様変更に伴い不要化
  // watch: {
  //   selectedItems: function (val, oldVal) {
  //     if (this.selectedItems.length > 0) {
  //       this.isPutBuckTransferSlipDisabled = false
  //       this.isOutputTransferSlipDisabled = false
  //     } else {
  //       this.isPutBuckTransferSlipDisabled = true
  //       this.isOutputTransferSlipDisabled = true
  //     }
  //   }
  // },
  mounted () {
    this.userId = localStorage.user_id
    const nowDate = this.getNowMonth(new Date())
    const nowFullYear = nowDate.getFullYear()
    const nowMonth = nowDate.getMonth() + 1 > 10 ? nowDate.getMonth() + 1 : '0' + (nowDate.getMonth() + 1)
    this.isDateSelected = true
    this.targetDate = nowFullYear + '-' + nowMonth
    const date = new Date()
    let y = date.getFullYear()
    let m = ('00' + (date.getMonth())).slice(-2)
    if (m === '00') {
      m = '12'
      y--
    }
    this.searchParams.fromInvoiceIssuanceMonth = y + '-' + m
    this.searchParams.toInvoiceIssuanceMonth = y + '-' + m
    this.load()
  },
  methods: {
    // map Vuex actions
    // ...mapActions('common', [SET_SEARCH_ITEM, SET_SELECT_ITEM, SET_SELECT_ALL_FLAG]),
    // NOTE: バリデートアラートのクローズ
    alertClose () {
      this.isValidAlert = false
    },
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    // NOTE: 検索実行
    // ボタン押下検索時はデフォルト引数としてthis.searchParamsを利用し、画面上で入力した検索条件を反映させ、リスト選択状態および内部選択保持を解除する
    // 暗黙再検索時は第1引数にthis.tmpSearchParamsを利用し、前回の検索条件で再度検索させる。内部選択リストおよび見た目上の選択状態を保持するかは第2引数のdoClearSelectedListで指定する
    async load (searchParams = this.searchParams, doClearSelectedList = true) {
      const isValid = await this.$refs.validationObserver.validate()
      if (!isValid) {
        this.isValidAlertMessage = []
        const validErrorObj = {}
        validErrorObj['itemName'] = '検索'
        validErrorObj['itemList'] = []
        const validError = this.$refs.validationObserver.errors
        Object.keys(validError).forEach(key => {
          if (validError[key].length !== 0) {
            validErrorObj['itemList'].push(validError[key][0])
          }
        })
        this.isValidAlertMessage.push(validErrorObj)
        this.isValidAlert = true
        return true
      }
      this.isLoadingTxt = LoadingTxt.getTxt
      this.isBusy = true
      // if (this.checkAllFlag) {
      //   this.checkAllFlag = false
      //   this.selectItem.splice(0)
      // }
      // let targetDate = null
      // if (this.isDateSelected) {
      //   targetDate = this.targetDate
      // }
      // let url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/transferslip/list?date=${targetDate}&tasid=${this.searchTextTasId}&paycomp=${this.isFilterOutputAndCompleted}&page=${this.currentPage}&limit=${this.perPage}&sort=${this.sortByKeyName}&desc=${this.sortDescSync}`
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/list'
      // this.$axios.get(url, {
      //   //  params: { 'user_id': this.userId
      //   // }

      //   ここでボタン押下検索だった場合のバリデートなどを行う。sortはthis.sortByKeyName(デフォルトの設定)にする
      if (searchParams === this.searchParams) {
        this.$refs.selectableTable.clearSort()
        searchParams.sort = this.sortByKeyName
        searchParams.desc = null
        this.$refs.selectableTable.scrollToTop()
      }
      // あくまでも引数として受け取ったsearchParamsを使うので、検索ボタン押下時や暗黙再検索時で使い分けてバックエンド処理に投げることができる
      const params = {
        datefrom: searchParams.fromInvoiceIssuanceMonth,
        dateto: searchParams.toInvoiceIssuanceMonth,
        ivstatus: searchParams.selectedStatus,
        tasid: searchParams.searchTextTasId,
        paycomp: false,
        page: searchParams.page,
        limit: searchParams.limit,
        sort: searchParams.sort,
        desc: searchParams.desc
      }
      try {
        const response = await this.$axios.get(url, { params: params })
        this.tableItems = response.data.records.headlines // レスポンスをtableItemsに格納しリスト表示
        this.listTotalRowCount = response.data.records.headlines.length // 件数を格納
        this.pagerItems['total'] = response.data.records.pager_items.total // ページングの件数
        this.pargingTotal = response.data.records.pager_items.total // ページングの件数 ※こちらを主に使う
        // this.reflect() // この処理が必要か不明
      } catch (e) {
        console.log(e)
        this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
      } finally {
        console.log('finally の処理を開始')
        this.isBusy = false
      }
      if (doClearSelectedList) {
        this.clearSelectedList() // 新規検索、ボタン処理実行時は内部選択リスト及び見た目上の選択状態をクリアする
        this.isAllChecked = false
      } else {
        this.checkJudgement() // ページングなど、内部選択リストをクリアせず見た目上の選択状態を再判定する
      }
      if (searchParams === this.searchParams) {
        Object.assign(this.tmpSearchParams, this.searchParams) // ボタン押下検索の場合、検索条件の一時保存を行う
      }
    },
    // リストが選択されたときの処理
    onRowSelected (items) {
      const tmpItems = this.selectItem
      const checkData = this.selectItem.findIndex(item => item.ID === items.item.ID)
      if (checkData !== -1) {
        // データが存在する場合（削除）
        tmpItems.splice(checkData, 1)
      //! this.checkAllFlag = false
      } else {
        // データが存在しない場合（追加）
        tmpItems.push({
          'ID': items.item.ID,
          'invoice_number': items.item.invoice_number,
          'invoice_status': items.item.invoice_status,
          'amount_billed_total': items.item.amount_billed_total
        })
      }
      this.selectItem = tmpItems
      // 手動で全行を選んだ場合に「全て選択」のチェックを入れる
      if (this.selectItem.length === this.pargingTotal) {
        this.isAllChecked = true
      }
    },

    // NOTE: 「全て選択」押下時にコールされる
    selectAllCheckToggle (value) {
      if (value) {
        this.selectAllRows()
      } else {
        this.clearSelectedList()
      }
    },
    // 全て選択がチェックされたとき
    selectAllRows () {
      this.isLoadingTxt = '全件選択処理中'
      this.isBusy = true
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/list'
      const params = {
        datefrom: this.searchParams.fromInvoiceIssuanceMonth,
        dateto: this.searchParams.toInvoiceIssuanceMonth,
        ivstatus: this.searchParams.selectedStatus,
        tasid: this.searchParams.searchTextTasId,
        paycomp: false,
        page: 1,
        limit: this.pargingTotal,
        sort: this.searchParams.sort,
        desc: this.searchParams.desc
      }
      this.$axios.get(url, { params: params }
      ).then(response => {
        this.selectItem = response.data.records.headlines
        this.checkJudgement()
      }).catch(error => {
        console.log(error)
        this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
      }).finally(() => {
        this.isBusy = false
      })
    },

    // NOTE:表示リストの選択状態を解除し、内部選択リストを空にする
    clearSelectedList () {
      this.$refs.selectableTable.clearSelected()
      this.selectItem.splice(0)
    },

    // NOTE: チェック判定
    checkJudgement () {
      this.$refs.selectableTable.clearSelected()
      let selectedCount = 0
      for (let i = 0; i < this.tableItems.length; i++) {
        const check = this.selectItem.some(item => item.ID === this.tableItems[i].ID)
        if (check) {
          this.$refs.selectableTable.select(this.tableItems[i], i)
          selectedCount++
        }
        if (selectedCount > this.selectItem.length) {
          break
        }
      }
    },

    // // NOTE: チェックボックス判定だったものgetter/setterが使われなくなるので不要
    // checkChange () {
    //   if (this.checkAllFlag) {
    //     this.isModalText = LoadingTxt.getTxt
    //     this.showLoading = true

    //     this.isLoadingTxt = LoadingTxt.getTxt
    //     this.isBusy = true
    //     let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/getAllId'
    //     this.$axios.get(url, {
    //       params:
    //         {
    //           datefrom: this.fromInvoiceIssuanceMonth,
    //           dateto: this.toInvoiceIssuanceMonth,
    //           status: this.selectedStatus,
    //           tasid: this.searchTextTasId,
    //           // paycomp: this.isFilterOutputAndCompleted
    //         }
    //     })
    //       .then(response => {
    //         this.selectItem.push(response.data.data)
    //         this.checkJudgement()
    //       })
    //       .catch(error => {
    //         console.log('transferSlip:getPageList', error)
    //         this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
    //       }).finally(() => {
    //         this.isBusy = false
    //       })
    //     // this.selectItem.push(this.tableItems)
    //   } else {
    //     this.selectItem.splice(0)
    //     this.checkJudgement()
    //   }
    //   this.SET_SELECT_ALL_FLAG(this.checkAllFlag)
    // },

    // 必要フラグ
    // changeBreakFlag () {
    //   this.breakFlag = true
    // },

    // // NOTE: load統合により不要
    // reflect () {
    //   // this.filteredTableItems = this.tableItems
    //   this.items = this.tableItems
    //   // this.filteredListTotalRowCount = this.filteredTableItems.length
    //   this.checkJudgement()
    //   this.isBusy = false
    // },
    // 計上年月で絞る オミット機能のためコメントアウト
    // filterDateSelected (checked) {
    //   this.isDateSelected = checked
    //   this.getPageList()
    //   // this.reflect()
    // },
    // 出力済と完了を除外する オミットされた機能の為、コメントアウト
    // filterOutputAndCompleted (checked) {
    //   // this.isFilterOutputAndCompleted = checked
    //   this.getPageList()
    //   // this.reflect()
    // },
    // 選択した顧客の、出力済振替伝票データを未出力に戻す
    async changeToNoOutput () {
      this.isLoadingTxt = LoadingTxt.allProcessingTxt
      this.isBusy = true
      // this.allSelected = false
      let items = []
      for (let i = 0; i < this.selectItem.length; i++) {
        if (this.selectItem[i]['invoice_status'] !== 7) {
          // this.$refs.selectableTable.unselectRow(i)
          //! this.$refs.selectableTable.onUnselectRow(i)
          let one = [this.selectItem[i]['ID'], 5]
          items.push(one)
        }
      }
      // 状況を未出力にデータを更新するAPIを叩く
      const url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/invoice_statuses'
      // this.showProcessingModal()
      try {
        await this.$axios.put(url, {
          'user_id': this.userId,
          'invoice_statuses': items
        })
      } catch (error) {
        console.log(error)
        this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
        this.isBusy = false
        // this.getPageList()
        // this.load()
        // this.reflect()
      } finally {
        this.$refs['ref-modal-1'].hide()
        // this.isBusy = false
      }
      await this.load(this.tmpSearchParams)
      this.isBusy = false
    },
    // 選択した顧客の、出力済振替伝票データを出力する
    onclickOutput () {
      // 選択(チェック)済み、かつ出力済みでないレコードを数える
      let count = 0
      for (let i = 0; i < this.selectItem.length; i++) {
        if (this.selectItem[i]['invoice_status'] !== 6) {
          count++
        }
      }
      if (count > 0) {
        // 一つ以上あるなら出力ダイアログを出す
        this.$refs['modal-output'].show()
      } else {
        // 一つもなければ出力可能なものがないと表示
        this.$refs['modal-output-none'].show()
      }
    },
    async changeOutput () {
      this.isLoadingTxt = LoadingTxt.allProcessingTxt
      this.isBusy = true
      let ids = []
      for (let i = 0; i < this.selectItem.length; i++) {
        if (this.selectItem[i]['invoice_status'] !== 6) {
          ids.push(this.selectItem[i]['ID'])
        }
        // this.sideMenuIds.push(this.selectItem[i]['ID'])
        // this.$refs.selectableTable.unselectRow(i)
        //! this.$refs.selectableTable.onUnselectRow(i)
      }
      // this.allSelected = false
      // const url1 = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/invoice_statuses/'
      // this.$axios.put(url1, {
      //   'user_id': 'userid',
      //   'user_token': 'usertoken',
      //   'device_type': 'devicetype',
      //   'ids': this.tableItems[i]['状況']
      // })
      //   .then(response => {
      //     this.load()
      //     this.reflect()
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
      //   .finally(() => {
      //   })
      let idsJson = JSON.stringify(ids)
      // 状況を未出力にデータを更新するAPIを叩く
      // const url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/invoice_status/' + this.tableItems[i]['ID']
      try {
        const url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/generateDat'
        const response = await this.$axios.put(url,
          {
            'user_id': this.userId,
            'ids': idsJson
          },
          {
            responseType: 'blob',
            dataType: 'binary'
          })
        let objUrl = URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = objUrl
        const dt = new Date()
        const y = dt.getFullYear()
        const m = ('00' + (dt.getMonth() + 1)).slice(-2)
        const d = ('00' + dt.getDate()).slice(-2)
        const filename = 'S25244-' + y + m + '(' + d + ')' + '.dat'
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        try {
          URL.revokeObjectURL(objUrl)
        } catch (e) {
          console.log(e)
        }
      } catch (error) {
        console.log('error', error)
        // サイドメニュー更新
        // this.updateSideMenuNotification('delete', '5-13', this.sideMenuIds, 'business_report_and_invoice')
        const isTimeout = error.code === 'ECONNABORTED'
        const timeoutMes = '指定件数が多すぎます。件数をご確認ください。'
        if (isTimeout) {
          this.$bvToast.toast(timeoutMes, { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
        }
        if (error.response) {
          if (error.response.status === 432) {
            this.$bvToast.toast(timeoutMes, { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
          } else {
            this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
          }
        } else {
          this.$bvToast.toast(timeoutMes, { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
        }
      } finally {
        this.hideProcessingModal()
        this.$refs['modal-output'].hide()
        // NOTE: リスト更新時までローディング処理を行いたいのでコメントアウト
        // this.isBusy = false
      }
      await this.load(this.tmpSearchParams)
      this.isBusy = false
    },
    /***
     *表示件数変更ボタンを押した時の処理
     */
    async onShowRowCountButonClick (e, currentPage) {
      this.tmpSearchParams.limit = e
      this.tmpSearchParams.page = 1
      await this.load(this.tmpSearchParams, false)
      this.$refs.selectableTable.scrollToTop()
    },
    // 必要か不明なのでコメントアウト
    // searchTasId () {
    //   this.getPageList()
    // },

    // ページ数取得用関数だったと思われるが、loadに統合したことで不要
    // getPageList () {
    //   const temporaryHolding = this.currentPage
    //   this.isLoadingTxt = LoadingTxt.getTxt
    //   this.isBusy = true
    //   // this.SET_SELECT_ITEM([])
    //   let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/transferslip/list'
    //   console.log(url)
    //   this.$axios.get(url, {
    //     params:
    //         {
    //           datefrom: this.fromInvoiceIssuanceMonth,
    //           dateto: this.toInvoiceIssuanceMonth,
    //           status: this.selectedStatus,
    //           tasid: this.searchTextTasId,
    //           // paycomp: this.isFilterOutputAndCompleted,
    //           page: this.currentPage,
    //           limit: this.perPage,
    //           sort: this.sortByKeyName,
    //           desc: this.sortDescSync
    //         }
    //   })
    //     .then(response => {
    //       this.tableItems = response.data.records.headlines
    //       this.listTotalRowCount = response.data.records.headlines.length
    //       this.pagerItems['total'] = response.data.records.pager_items.total
    //       this.currentPage = 1
    //       this.reflect()
    //     })
    //     .catch(error => {
    //       console.log('transferSlip:getPageList', error)
    //       this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
    //     }).finally(() => {
    //       this.isBusy = false
    //       this.currentPage = temporaryHolding
    //     })
    // },
    /* onFiltere の機能確認が必要な為、コメントアウト
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    */

    getNowMonth (date) {
      console.log('今日は' + date + '今月は' + date.getMonth() + 'です')
      // NOTE:月を-1することで指定された日時の前月を求めている。1月の場合、前年の12月の日付が生成されることを確認済み。
      return new Date(date.getFullYear(), date.getMonth(), 1)
    },
    showProcessingModal () {
      this.$refs['refProcessingModal'].show()
    },
    hideProcessingModal () {
      this.$refs['refProcessingModal'].hide()
    },
    // NOTE: ページング再検索
    async pagingSearchingAgain (e) {
      this.tmpSearchParams.page = e
      await this.load(this.tmpSearchParams, false)
      this.$refs.selectableTable.scrollToTop()
    },
    // NOTE: ソート項目変更時の処理
    async sortChanged (e) {
      this.tmpSearchParams.sort = e.sortBy
      this.tmpSearchParams.desc = e.sortDesc
      this.tmpSearchParams.page = 1
      await this.load(this.tmpSearchParams)
      this.$refs.selectableTable.scrollToTop()
    },
    invoiceIssuanceMonthClear () {
      this.searchParams.fromInvoiceIssuanceMonth = ''
      this.searchParams.toInvoiceIssuanceMonth = ''
      this.$refs['from-invoice-issuance-month'].$el.value = ''
      this.$refs['to-invoice-issuance-month'].$el.value = ''
      this.$refs.fromInvoiceIssuanceMonth.reset()
      this.$refs.toInvoiceIssuanceMonth.reset()
    },
    // NOTE: 検索項目のクリア
    searchItemClear () {
      this.searchParams.searchTextTasId = ''
      this.searchParams.selectedStatus = 0
      this.invoiceIssuanceMonthClear()
    },
    changeSelectAction (value) {
      this.selected = value
    }
  },
  computed: {
    // map Vuex getters
    // ...mapGetters('common', ['searchItem', 'selectItem', 'selectAllFlag']),
    // NOTE: getter/setter不要化につきコメントアウト
    // checkAll: {
    //   get () {
    //     return this.checkAllFlag
    //   },
    //   set (value) {
    //     this.checkAllFlag = value
    //     this.checkChange()
    //   }
    // },

    // ページングをgetter/setterで管理したくないので不要
    // changeCurrentPage: {
    //   get () {
    //     return this.currentPage
    //   },
    //   set (value) {
    //     this.currentPage = value
    //     this.getPageList()
    //   }
    // },
    computedItems () {
      return this.items
    },
    computedCurrentPage () {
      return this.tmpSearchParams.page
    },
    computedPerPage () {
      return this.tmpSearchParams.limit
    },
    // リストの総件数
    computedListTotalRowCount () {
      return this.pargingTotal
    },
    // 請求件数
    computedInvoiceListCount () {
      return this.selectItem.length
    },
    // 合計金額
    computedListBilledAmountTotal () {
      let total = 0
      for (let i = 0; i < this.selectItem.length; i++) {
        total += this.selectItem[i].amount_billed_total
      }
      return total.toLocaleString('ja-JP')
    },
    selectActions () {
      return [
        {
          value: 0,
          text: '選択してください',
          event: null,
          disabled: true
        },
        {
          value: 1,
          text: '選択した顧客の、出力済振替伝票データを未出力に戻す',
          event: () => {
            this.$bvModal.show('modal-1')
          },
          disabled: this.selectItem.length === 0
        },
        {
          value: 2,
          text: '選択した顧客の、振替伝票データを出力する',
          event: () => {
            this.onclickOutput()
          },
          disabled: this.selectItem.length === 0
        }
      ]
    },
    stateSelectActions () {
      return {
        disabledBtn: this.selectItem.length === 0,
        selected: this.selectItem.length === 0 ? 0 : this.selected
      }
    }
    // checkAll: {
    //   get () {
    //     if (this.filteredTableItems.length === this.selectedItems.length && this.filteredTableItems.length > 0) {
    //       return true
    //     } else {
    //       return false
    //     }
    //   },
    //   set (value) {
    //     if (value) {
    //       this.selectAllRows()
    //     } else if (this.filteredTableItems.length === this.selectedItems.length && this.filteredTableItems.length > 0) {
    //       this.clearSelected()
    //     }
    //   }
    // }
  },
  beforeUpdate () {
    this.filteredListTotalRowCount = this.pagerItems['total']
  }
  // NOTE: vuexを初期化
  // NOTE: →vuex削除に伴いコメントアウト
  // beforeDestroy () {
  //   if (!this.setSearchItemResetFlag) {
  //     this.SET_SEARCH_ITEM(null)
  //     this.SET_SELECT_ITEM([])
  //     this.SET_SELECT_ALL_FLAG(false)
  //   }
  // }

}
</script>
<style lang="scss" scoped>
.output__btn {
  width: 104px;
}
.cancel__btn {
  width: 118px;
}
</style>
